import React from 'react';

// import {
//   TextNodeModal,
//   TextSnippetNodeModal,
//   NoteNodeModal,
//   DocumentNodeModal,
//   ImageNodeModal,
//   ProtocolNodeModal,
//   RisSearchModal,
//   SurfaceNodeModal,
//   QuestionnaireNodeModal,
//   BackgroundNodeModal,
// } from 'routes/surface/style';
import LinkArrow from 'components/canvas/components/link-arrow';
import CollaboratingUsersCursors, {
  useCollaboratingCursorListeners,
} from 'routes/surface/components/collaborating-users-cursors';
import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { useHistory, useParams } from 'react-router-dom';
import { configuration } from 'components/pspdf';
import { Line } from 'react-konva';
import useFetchSurfaceNodes from 'components/canvas/components/nodes/hooks/use-fetch-surface-nodes';
// import { Container } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import { Container, Grid, List, ListItem, Typography } from '@mui/material';
import { Fab, ListItemText, Toolbar } from '@material-ui/core';
import styled from 'styled-components';
import useFetchLoggedUser from 'hooks/use-fetch-logged-user';
import { useQuery } from '@apollo/client';
import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';

import { red } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from 'styled-components';

import client from 'services/apollo-client';
import Table from './table';
import logo from 'styles/icons/immoOx-Text.png';
import logo1 from 'styles/icons/LogoImmo.png';
import { media } from 'styles/settings';
import { withPortratitGuard } from 'routes/share/template-page/guard';

const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
  },
});
const Item2 = ({ node, onClick }) => {
  var sub = null;

  if (node.type == 'TEXT') {
    sub = (
      <React.Fragment>
        <Typography
          sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {node.text}
        </Typography>
      </React.Fragment>
    );
  }

  if (node.type == 'NOTE') {
    sub = (
      <React.Fragment>
        <Typography
          sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {node.text}
        </Typography>
        <Typography
          // sx={{ display: 'inline' }}
          component="div"
          variant="body2"
          color="text.primary">
          {`http://localhost:3000/share/template/${node.text.split(':')[2]}/${
            node.surface.id
          }`}
        </Typography>
      </React.Fragment>
    );
  }

  return (
    <ListItemText
      primary={node.name}
      secondary={sub}
      onClick={node.type == 'SUB_SURFACE' ? onClick : null}
    />
  );
};

export const Div = styled.div`
  /* background-color: red; */
  height: 100dvh;
  background: ${({ theme }) => theme.background};

  /* position: absolute; */
`;

const Title = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 40px;
  /* position: absolute; */
`;

const AddButton = styled.div`
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  /* height: 100vh; */
  color: ${({ theme }) => theme.textInv};
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  padding: 8px;
  width: 300px;
  cursor: pointer;

  /* position: absolute; */
`;

const Fab_ = styled(Fab)`
  /* background-color: red; */
  /* height: 100vh; */

  /* position: absolute; */
  /* right: 0; */

  /* position: absolute; */
  margin: 0;
  top: auto;
  right: 20;
  bottom: 20;
  left: auto;
  position: fixed;
`;
const Item = styled.div`
  /* background-color: red; */
  /* height: 100%; */

  /* position: absolute; */
`;
// function Item({ node }) {}

export const HeaderStyledLogoIconImmo = styled.img.attrs(({ src }) => ({
  src: logo1,
  alt: 'Article Cover',
}))`
  position: absolute;
  /* width: 128px; */
  height: 80px;
  object-fit: contain;
  top: 8px;
  left: 8px;
`;

export const HeaderStyledLogoIconImmoText = styled.img.attrs(({ src }) => ({
  src: logo,
  alt: 'Article Cover',
}))`
  position: absolute;
  /* width: 128px; */
  height: 80px;
  object-fit: contain;
  bottom: 8px;
  left: 8px;
  ${media.mediaQueries.mobile`
      display:none;
  `}
`;

export const HeaderStyledLogoIconImmoTextTop = styled.img.attrs(({ src }) => ({
  src: logo,
  alt: 'Article Cover',
}))`
  position: absolute;
  /* width: 128px; */
  height: 60px;
  object-fit: contain;
  top: 8px;
  right: 8px;
`;

function ListNik() {
  const { id } = useParams<{ id: string }>();

  const history = useHistory();

  // const { user } = useFetchLoggedUser();

  const { nodes, loading } = useFetchSurfaceNodes(id);

  const { data, loading: loadingCell } = useQuery<any>(homeSurfaceQuery, {
    client,
    // fetchPolicy: 'network-only',
  });
  // const { showNodeModal } = useSurfaceNodeModalsOperations();

  // useNodeSearchParams(showNodeModal);

  // useCollaboratingCursorListeners(id);

  // React.useEffect(() => {
  //   if (process.env.NODE_ENV === 'production') {
  //     setTimeout(() => PSPDFKit.preloadWorker(configuration), 3000);
  //   }
  // }, []);

  const navigateToSurface = React.useCallback((surfaceId: string) => {
    history.push('/immo-ox/detail/' + surfaceId);
  }, []);

  const navigateToTemplate = React.useCallback((surfaceId: string) => {
    history.push('/immo-ox/template/' + surfaceId);
  }, []);

  console.log('AAAA', nodes);
  if (loading || loadingCell) {
    return 'Loading';
  }

  const isRoot = data?.homeSurface?.data?.id == id;

  console.log('Data ', isRoot, data);

  const no = isRoot ? nodes.filter((n) => n.type == 'SUB_SURFACE') : nodes;

  return (
    <>
      <Div>
        <HeaderStyledLogoIconImmo />
        <HeaderStyledLogoIconImmoText />
        <Toolbar></Toolbar>
        {isRoot && (
          <Container maxWidth="lg">
            {/* <Stack spacing={2}>

          {nodes.map((n) => {
            return <Item node={n}> </Item>;
          })}
        </Stack> */}

            {/* <Grid container spacing={2}>
            <Grid item xs={6} md={8}>
              <Item>xs=6 md=8</Item>
            </Grid>
            <Grid item xs={6} md={4}>
              <Item>xs=6 md=4</Item>
            </Grid>
            <Grid item xs={6} md={4}>
              <Item>xs=6 md=4</Item>
            </Grid>
            <Grid item xs={6} md={8}>
              <Item>xs=6 md=8</Item>
            </Grid>
          </Grid> */}
            <Title>Projektübersicht</Title>

            <Table
              entries={no}
              handleClickP={(a, node) => {
                navigateToSurface(node.id);
              }}></Table>
            {isRoot && (
              <AddButton onClick={() => navigateToTemplate(id)}>
                Neues Projekt starten
              </AddButton>
            )}
          </Container>
        )}
        {!isRoot && (
          <List
            sx={{
              height: 'calc(90vh - 200px)',
              overflow: 'auto',
              width: '100%',
              maxWidth: 1200,
              bgcolor: 'background.paper',
            }}>
            {no.map((node) => {
              return (
                <ListItem alignItems="flex-start">
                  <Item2
                    node={node}
                    onClick={() => navigateToSurface(node.id)}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </Div>
      {/* // {isLoading === false && <SurfaceSubscriptionListeners surface={id} />}

      // <Canvas
      //   id={id}
      //   isLoading={isLoading}
      //   renderBelowCanvas={({ stage }) => (
      //     <>
      //       <TextNodeModal ref={modalRefs.textNodeModal} onHide={onModalHide} />

      //       <NoteNodeModal ref={modalRefs.noteNodeModal} onHide={onModalHide} />
      //       <TextSnippetNodeModal
      //         ref={modalRefs.textSnippetNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <DocumentNodeModal
      //         ref={modalRefs.documentNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <SurfaceNodeModal
      //         ref={modalRefs.surfaceNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ProtocolNodeModal
      //         ref={modalRefs.protocolNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <BackgroundNodeModal ref={modalRefs.backgroundNodeModal} onHide={onModalHide} />
      //       <QuestionnaireNodeModal
      //         ref={modalRefs.questionnaireNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ImageNodeModal
      //         ref={modalRefs.imageNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <RisSearchModal
      //         ref={modalRefs.risSearchModal}
      //         onHide={onModalHide}
      //       />

      //       <TopLeftMenu />

      //       <TopRightMenu />

      //       <SideMenu
      //         stage={stage}
      //         showNodeModal={showNodeModal}
      //         modalTypeShown={modalTypeShown}
      //         surface={id}
      //       />

      //       <SideDrawer />

      //       <NotificationSideDrawer />

      //       <IndicatorZoneMenu>
      //         <GlobalLinkZoneIndicator />
      //         <ClipboardZoneIndicator />
      //       </IndicatorZoneMenu>

      //       {isLoading === false && (
      //         <MiniMap surface={id} nodes={nodes} isLoading={isLoading} />
      //       )}
      //       <SurfaceLinkContextMenu />
      //     </>
      //   )}>
      //   {() => {
      //     if (error) return null;
      //     console.log("XXX" , nodes)
      //     return (
      //       <>
      //         <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename === "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //          <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename !== "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //         <CollaboratingUsersCursors />
      //       </>
      //     );
      //   }} */}
      {/* <ToolbarProvider>
        <SurfaceSubscriptionListeners surface={id} />
        <FileUploadZone surface={id}>
          <Canvas id={id}>
            <Nodes surface={id} navigateToSurface={navigateToSurface} />
            <LinkArrow surface={id} />
            <CollaboratingUsersCursors />
          </Canvas>
        </FileUploadZone>
        <SurfaceNodeModals />

        <TopLeftMenu />

        <TopRightMenu />

        <SideMenu surface={id} />

        <PaintMenu />

        <SideDrawer />

        <NotificationSideDrawer />

        <MiniMap surface={id} />
      </ToolbarProvider> */}
    </>
  );
}

function Themed(props) {
  const themeStyled = useTheme();
  return (
    <ThemeProvider theme={{ ...theme, ...themeStyled }}>
      <ListNik {...props} />
    </ThemeProvider>
  );
}

// return <ThemeProvider theme={theme}>...</ThemeProvider>;

export default withPortratitGuard(Themed);
